// extracted by mini-css-extract-plugin
export default {"templatesByCategories":"CategoriesWithTemplates_templatesByCategories__Lyz1h","uncategorized":"CategoriesWithTemplates_uncategorized__EB+oL"};